import {definePreset} from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const MyPreset = definePreset(Aura, {
  primitive: {
    blue: {
      50: '#eef4ff',
      100: '#dce8ff',
      200: '#b9cfff',
      300: '#8fb2ff',
      400: '#4d82ff',
      500: '#075cf6',
      600: '#0552dc',
      700: '#0445b8',
      800: '#06388f',
      900: '#092b62',
      950: '#081b2b'
    }
  },
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    },
    colorScheme: {
      light: {
        surface: {
          900: '{blue.900}',
          950: '{blue.950}'
        },
        primary: {
          color: '{blue.500}',
          hoverColor: '{blue.600}',
          activeColor: '{blue.700}'
        },
        highlight: {
          background: '{blue.50}',
          focusBackground: '{blue.100}',
          color: '{blue.700}',
          focusColor: '{blue.800}'
        }
        },
        dark: {
          surface: {
            900: '{zinc.900}',
            950: '{zinc.950}'
          }
      },
    }
  },
  components: {
    inputtext: {
      root: {
        paddingX: '0.625rem',
        paddingY: '0.375rem',
      }
    },
    select: {
      root: {
        paddingX: '0.625rem',
        paddingY: '0.375rem',
      }
    },
    multiselect: {
      root: {
        paddingX: '0.625rem',
        paddingY: '0.375rem',
      }
    },
    button: {
      root: {
        paddingX: '0.625rem',
        paddingY: '0.375rem',
      }
    },

    breadcrumb: {
      colorScheme: {
        dark: {
          item: {
            color: '#f4f4f5'
          },
          separator: {
            color: '#71717a'
          }
        }
      }
    },
  }
});

export default MyPreset;
